import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token (preview environment iframes the app, so httpOnly cookies
// are not reliably persisted — we use a localStorage token as the primary mechanism).
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (t) => {
  if (t) localStorage.setItem("pg_token", t);
  else localStorage.removeItem("pg_token");
};

export const money = (n) =>
  n == null ? "$0.00" : `$${Number(n).toFixed(2)}`;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fileUrl = (path) => `${API}/files/${path}`;

const CUSTOM_LABELS = { name: "Name on Back", academy_line: "Academy / Location" };
export const customText = (c) =>
  Object.entries(c || {}).filter(([, v]) => v && typeof v === "string")
    .map(([k, v]) => `${CUSTOM_LABELS[k] || k}: ${v}`).join(" · ");
